/**
 * PhoenixSuperLink
 *
 * A web component that provides a clickable container element.
 *
 * Sample markup:
 *
 *   <phoenix-super-link
 *     href="..."
 *     target="...">
 *     ... other markup ...
 *   </phoenix-super-link>
 *
 */
'use strict';

const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:superLink');

class PhoenixSuperLink extends HTMLElement {
    connectedCallback() {
        this.href = this.getAttribute('href');
        if (!this.href) {
            // if there actually _wasn't_ a href assigned, allow the click
            // event to be handled naturally
            return;
        }
        this.clickListener = this.onClick.bind(this);
        this.addEventListener('click', this.clickListener, false);
    }

    onClick(event) {
        // update href in case a new attribute is set after connectedCallback, for example in card/main.js
        this.href = this.getAttribute('href');
        // ignore click if target of click is a link, button, or other element
        // that is naturally clickable
        var eventTarget = event.target,
            clickableElements = ['A', 'BUTTON', 'LABEL', 'INPUT', 'SELECT', 'OPTION', 'OPTGROUP', 'TEXTAREA'];

        while (eventTarget && eventTarget !== this) {
            if (clickableElements.indexOf(eventTarget.nodeName) !== -1) {
                return;
            }
            eventTarget = eventTarget.parentElement;
        }

        // we'll handle this click
        event.stopPropagation();
        event.preventDefault();

        var target = this.getAttribute('target');
        if (target) {
            window.open(this.href, target);
        } else {
            window.location.href = this.href;
        }
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.clickListener);
    }
}

window.customElements.define('phoenix-super-link', PhoenixSuperLink);
measure.end();
